import { useEffect, useRef } from "react";
import { KEY_EVENT } from "./Critter";
import "./Key.css";

/**
 * A physical-looking keycap. `kind` picks the color set:
 * alpha (light), mod (grey), accent (orange), space (inverted).
 */
const Key = ({
  label,
  sub,
  kind = "alpha",
  width,
  big = false,
  pressed = false,
  onPress,
  ariaLabel,
}) => {
  const ref = useRef(null);

  // Lets the critter know a key went down, so it can react
  useEffect(() => {
    if (!pressed) return;
    const box = ref.current.getBoundingClientRect();
    window.dispatchEvent(
      new CustomEvent(KEY_EVENT, {
        detail: { x: box.left + box.width / 2, y: box.top + box.height / 2 },
      })
    );
  }, [pressed]);

  return (
    <button
      ref={ref}
      type="button"
      className={`key key--${kind}${big ? " key--big" : ""}${
        pressed ? " is-pressed" : ""
      }`}
      // Shrinks in proportion to its width when the keyboard is narrower than designed
      style={width ? { flex: `0 1 ${width}px` } : undefined}
      onClick={onPress}
      aria-label={ariaLabel || label}
    >
      <span className="key__label">{label}</span>
      {sub && <span className="key__sub">{sub}</span>}
    </button>
  );
};

export default Key;
